import React from 'react';
import { NavLink } from 'react-router-dom';
import { menuData } from '../../config/menuData.js';
import { useAuth } from '../../context/AuthContext.jsx';
import { canAccess } from '../../config/roles.js';
import './bottomnav.scss';

// Thumb-reachable BOTTOM tab bar for mobile / narrow viewports — the third
// layer of the unified nav (top → side drawer → bottom). Shows the first few
// role-permitted destinations as tabs plus a "More" tab that opens the full
// grouped side drawer. Reuses the role filtering + active-state from the rest
// of the nav (canAccess + menuData).
const MAX_TABS = 4;

export default function BottomNav({ onMore }) {
  const { user } = useAuth();

  const leaves = menuData.children
    .flatMap((group) => group.children || [])
    .filter((item) => canAccess(user, item.slug));

  const tabs = leaves.slice(0, MAX_TABS);

  return (
    <nav className="bottom-nav" aria-label="Primary mobile navigation">
      <ul className="bottom-nav-list">
        {tabs.map((item) => (
          <li key={item.slug} className="bottom-nav-item">
            <NavLink
              to={`/${item.slug}`}
              className={({ isActive }) => `bottom-nav-link ${isActive ? 'active' : ''}`}
            >
              {item.icon && <i className={`${item.icon} bottom-nav-icon`} aria-hidden="true" />}
              <span className="bottom-nav-label">{item.label}</span>
            </NavLink>
          </li>
        ))}
        {/* "More" opens the full grouped side drawer. */}
        <li className="bottom-nav-item">
          <button type="button" className="bottom-nav-link" onClick={onMore} aria-label="More navigation">
            <i className="fa fa-ellipsis-h bottom-nav-icon" aria-hidden="true" />
            <span className="bottom-nav-label">More</span>
          </button>
        </li>
      </ul>
    </nav>
  );
}
